import './Book.css';
import BookInfo from "./BookInfo.js";
import { processTouchCode, openContents } from "./func/bookend-api.js";
import { useState } from 'react';

function DownloadBook(props) {

 const { cInfo, code, project, isInvalid, errorMessage } = props;
 const img_url = cInfo.ThumbnailURL;
 const [isFlipped, setIsFlipped] = useState(false); // 表紙がめくれた状態を管理

 const btn_style = {};

  // 本全体がクリックされたときの処理
  const handleBookClick = () => {
   // 無効なカードの場合はめくれないようにする
   if (isInvalid) {
    return;
   }
   // まだめくれていない場合のみ、めくる
   if (!isFlipped) {
    setIsFlipped(true);
   }
  };

 return (
   <figure className={`book ${isFlipped ? 'flipped' : ''} ${isInvalid ? 'invalid' : ''}`} style={btn_style} onClick={handleBookClick}>
    <div className='hardcover_front'>
      <div className="coverDesign">
       {isInvalid && (
        <div className="error-overlay">
         <p>{errorMessage}</p>
        </div>
       )}
       {/*<span className="ribbon">NEW</span>*/}
       <img src={img_url} alt="thumb" className={`coverThumb ${isInvalid ? 'invalid' : ''}`}></img>
      </div>
     <div></div>
    </div>
    <ul className='page'>
     <li>
      <div className="page-content"></div>
     </li>
     <li>
      <div className="page-content">
        <BookInfo cInfo={cInfo}/>
        {!isInvalid && (
         <div className="btn" onClick={handleDownload}>ダウンロード</div>
        )}
      </div>
     </li>
     <li>
      <div className="page-content"></div>
     </li>
     <li>
      <div className="page-content"></div>
     </li>
     <li>
      <div className="page-content"></div>
     </li>
     <li>
      <div className="page-content"></div>
     </li>
    </ul>
    <ul className='hardcover_back'>
     <li></li>
     <li></li>
    </ul>
    <ul className='book_spine'>
     <li></li>
     <li></li>
    </ul>
   </figure>
 );

 function handleDownload(e){
  // 親要素(figure)へのクリックイベントの伝播を防ぐ
  e.stopPropagation();
  processTouchCode(code, project, onDownloadInfoReceived);
 }

 function onDownloadInfoReceived(data){
  if (data && data.downloadInfo) {
    const { downloadId, contentId, contentType, authKey } = data.downloadInfo;
    // bookend.jsの関数を呼び出してコンテンツを開く
    openContents(contentId, downloadId, contentType, authKey, cInfo);
  } else if (data && data.message) {
    // サーバーから返されたステータスメッセージを表示
    alert(data.message);
    console.error('Info from server:', data.message);
  } else {
    // その他のエラーハンドリング
    alert('ダウンロード情報の取得に失敗しました。');
    console.error('Failed to get download info:', data);
  }
 }
}

export default DownloadBook;